import React from 'react';
import axios from 'axios';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class TrainingQueue extends React.Component {
  label = () => {
    return "Участники";
  }

  message = () => {
    return "Очередь на тренировку пока пуста";
  }

  players = () => {
    return (
      <React.Fragment>
        <PlayersInner
          key={1}
          label={this.label()}
          message={this.message()}
          players={this.props.game.playersQueued}
          totalPlayersNum={this.props.game.playersQueued.length}
          playersCount={false}
          flag={""}
        />
      </React.Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default TrainingQueue;
